import { render } from "./ValidationCode.vue?vue&type=template&id=137beefe&scoped=true&ts=true"
import script from "./ValidationCode.vue?vue&type=script&lang=ts"
export * from "./ValidationCode.vue?vue&type=script&lang=ts"

import "./ValidationCode.vue?vue&type=style&index=0&id=137beefe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137beefe"]])

export default __exports__